/** Allowed tags for config-driven inline HTML (e.g. NY retention disclosure). */
const ALLOWED_TAGS = new Set(['B', 'STRONG', 'EM', 'I', 'BR', 'P', 'SPAN'])

function cleanElement(el: Element): void {
  let i = 0
  while (i < el.childNodes.length) {
    const node = el.childNodes[i]
    if (node.nodeType === Node.TEXT_NODE) {
      i += 1
      continue
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
      el.removeChild(node)
      continue
    }
    const child = node as Element
    if (!ALLOWED_TAGS.has(child.tagName)) {
      while (child.firstChild) {
        el.insertBefore(child.firstChild, child)
      }
      el.removeChild(child)
      continue
    }
    while (child.attributes.length > 0) {
      child.removeAttribute(child.attributes[0].name)
    }
    cleanElement(child)
    i += 1
  }
}

/**
 * Strips disallowed tags (unwraps children) and removes all attributes from allowed tags.
 * Mitigates XSS when rendering trusted-but-structured config HTML.
 */
export function sanitizeLimitedInlineHtml(html: string): string {
  if (!html || typeof document === 'undefined') {
    return html
  }
  const doc = new DOMParser().parseFromString(html, 'text/html')
  cleanElement(doc.body)
  return doc.body.innerHTML
}
